import type { RealtimeEvents } from '@nw/shared';
import { useEffect } from 'react';
import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;

function getSocket(): Socket {
  socket ??= io('/rt', { withCredentials: true, transports: ['websocket'] });
  return socket;
}

/** Subscribe to a server push event (namespace /rt). */
export function useRealtime<E extends keyof RealtimeEvents>(event: E, handler: (payload: RealtimeEvents[E]) => void): void {
  useEffect(() => {
    const s = getSocket();
    const h = (p: RealtimeEvents[E]) => handler(p);
    s.on(event as string, h as never);
    return () => {
      s.off(event as string, h as never);
    };
  }, [event, handler]);
}
